import { useQuery } from "@tanstack/react-query";
import { getOutboxDashboard } from "../services/outboxApi";
import { OutboxDashboardData } from "../types/outbox.types";

const OUTBOX_DASHBOARD_QUERY_KEY = "outboxDashboard";

interface UseOutboxDashboardOptions {
  isReplaying?: boolean;
}

export const useOutboxDashboard = (options: UseOutboxDashboardOptions = {}) => {
  const { isReplaying = false } = options;

  return useQuery<OutboxDashboardData, Error>({
    queryKey: [OUTBOX_DASHBOARD_QUERY_KEY],
    queryFn: async () => {
      const response = await getOutboxDashboard();
      return response.data;
    },
    refetchInterval: isReplaying ? false : 10000, // Pause during replay, 10 seconds otherwise
    refetchIntervalInBackground: false,
    staleTime: 5 * 1000, // 5 seconds - match backend cache TTL
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
  });
};

export default useOutboxDashboard;
